<p class="mk-muted" *ngIf="state.loading">Loading the items&hellip;</p>
<p class="fx-error" role="alert" *ngIf="state.loadError">Couldn't load the items. Close this and try again.</p>

<div class="mk-card fx" *ngFor="let clash of state.clashes; trackBy: trackClash">
  <b class="fx-title">{{ title(clash) }}</b>
  <p class="mk-muted">{{ sub(clash) }}</p>
  <ul class="fx-rows">
    <li class="fx-code-row" *ngFor="let row of clash.rows; trackBy: trackRow">
      <b class="fx-code-name" *ngIf="clash.rows.length > 1">{{ row.name }}</b>
      <label class="fx-code-label" [for]="idPrefix + 'code-' + row.itemId">{{ fieldLabel }}</label>
      <div class="fx-code-edit">
        <input
          class="fx-code-input"
          [class.bad]="message(row).tone === 'bad'"
          [id]="idPrefix + 'code-' + row.itemId"
          [value]="row.draft"
          [attr.aria-describedby]="idPrefix + 'code-msg-' + row.itemId"
          autocomplete="off"
          spellcheck="false"
          [disabled]="row.saving"
          (input)="state.setDraft(row, $any($event.target).value)"
          (keydown.enter)="canSave(row) && state.save(row)"
        />
        <span class="fx-count" [class.over]="length(row) > row.limit">{{ length(row) }}/{{ row.limit }}</span>
        <button type="button" class="btn-teal-gradient fx-save" [disabled]="!canSave(row)" (click)="state.save(row)">
          {{ row.saving ? 'Saving…' : 'Save' }}
        </button>
      </div>
      <div class="fx-msg" [ngClass]="message(row).tone" [id]="idPrefix + 'code-msg-' + row.itemId" aria-live="polite">
        <span *ngIf="message(row).text">{{ message(row).text }}</span>
        <button type="button" class="link-btn" *ngIf="suggestion(row) as free" (click)="state.setDraft(row, free)">Use {{ free }}</button>
      </div>
    </li>
  </ul>
</div>
